let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eiX79")).then(() => parcelRequire('dtKTo'));